import { RequestTemplateKickstarterBanner } from "@/components/kickstarter-banner/banners";
import { useDuplicateTemplate } from "@/features/templates/hooks/useDuplicateTemplate";

import { EditRequestLayout } from "../request/edit/components/EditRequestLayout";

export function MockedEditRequestPage() {
  return <EditRequestLayout banner={<BannerForModelRequest />} />;
}

function BannerForModelRequest() {
  const { handleCreateDraft } = useDuplicateTemplate();

  return (
    <div className="px-[20px] max-w-screen-2xl w-full items-center mx-auto">
      <RequestTemplateKickstarterBanner createDraft={handleCreateDraft} />
    </div>
  );
}
